import { render, staticRenderFns } from "./SettingCard.vue?vue&type=template&id=4799d3bd&scoped=true"
import script from "./SettingCard.vue?vue&type=script&lang=ts"
export * from "./SettingCard.vue?vue&type=script&lang=ts"
import style0 from "./SettingCard.vue?vue&type=style&index=0&id=4799d3bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4799d3bd",
  null
  
)

export default component.exports